import { Flex, Tag } from 'antd';
import { useCallback } from 'react';

import type { BottomContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import {
  PF,
  GENDERS_OPTIONS,
} from '@pages/Clients/NewClientsList/data/constants';
import type { GenderItem } from '@pages/Clients/NewClientsList/types';

export const GenderSelected: BottomContentType = ({ id }) => {
  const { filtersMap, onChangeGenders } = useNewClientsListContext();

  const { genders } = filtersMap.get(id)!;

  const onClose = useCallback(
    (value: GenderItem['value']) => {
      const newGenders = genders.filter((gender) => gender !== value);
      onChangeGenders(newGenders, id);
    },
    [genders, onChangeGenders, id]
  );

  if (genders.length === 0) {
    return null;
  }

  const selectedGenders: GenderItem[] = GENDERS_OPTIONS.filter((gender) =>
    genders.includes(gender.value)
  );

  return (
    <Flex className={`${PF}__tags`} wrap="wrap" gap="4px">
      {selectedGenders.map(({ value, label }) => (
        <Tag
          key={value}
          className={`${PF}__tag`}
          closable
          onClose={() => onClose(value)}
        >
          {label}
        </Tag>
      ))}
    </Flex>
  );
};
